import dayjs from 'dayjs'

import { CompletePageConditionalRuleModel } from '@/domain/model/forms'

export const transformFromCompletePageStateToForm = (
  responses?: CompletePageConditionalRuleModel[]
): CompletePageConditionalRuleModel[] => {
  if (!responses || !responses.length) {
    return []
  }

  return responses.map((response) => ({
    ...response,
    is_new: response.is_new ?? false,
    is_updated: response.is_updated ?? false,
    conditional_rule_groups: response?.conditional_rule_groups?.map(
      (group) => ({
        conditional_rules: group?.conditional_rules?.map((rule) => {
          let expected_answer = rule?.expected_answer ?? undefined

          if (
            typeof expected_answer === 'string' &&
            expected_answer?.includes(',')
          ) {
            expected_answer = expected_answer?.split?.(',')
          } else if (
            typeof expected_answer === 'string' &&
            expected_answer?.includes('T')
          ) {
            expected_answer = dayjs(
              expected_answer as unknown as string
            ) as unknown as string
          }
          return {
            ...rule,
            expected_answer,
          }
        }),
      })
    ),
  }))
}
